module.exports = __webpack_public_path__ + "static/media/larr.417cc63e.svg";